
// Nothing the user can do anymore, this is too late.
const FulfilledActions = (props) => {

  return null;
}

export default FulfilledActions;